import { useContext } from "react";

import { useMuxSpecificationApi } from "../../../../../common/api/orders-api/mux-specification/useMuxSpecificationApi";
import { MuxerType } from "../../../../../common/types/MuxerType";
import { EncodeSpecificationType } from "../../../../encode-specification/context/EncodeSpecificationItem";
import { MuxSpecificationListingContext } from "../../../context/MuxSpecificationListingContext";
import { CreateGpacMuxSpecificationFormInputs } from "./CreateGpacMuxSpecificationForm";

export const useCreateGpacMuxSpecificationForm = () => {
    const { createGpacMuxSpecification: createGpac } = useMuxSpecificationApi();
    const { add: addMuxSpeficicationToContext } = useContext(MuxSpecificationListingContext);

    const createGpacMuxSpecification = async ({
        name,
        command,
        soundtracksCommand,
        subtitlesCommand
    }: CreateGpacMuxSpecificationFormInputs) => {
        const response = await createGpac({
            name,
            command,
            soundtracksCommand,
            subtitlesCommand
        });

        addMuxSpeficicationToContext({
            id: response.entityId,
            name,
            type: MuxerType.GPAC,
            details: {
                type: MuxerType.GPAC,
                command,
                soundtracksCommand,
                subtitlesCommand
            },
            encodeSpecificationType: EncodeSpecificationType.MPEG_4,
            updatedDate: new Date().toISOString()
        });
    };

    return {
        createGpacMuxSpecification
    };
};
